export { StoreContactInfo } from './StoreContactInfo';
